import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || (window.location.hostname === 'localhost' ? "http://localhost:8000" : "https://yoursdreamdecoration-backend.onrender.com");
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ydd_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;

export const formatErr = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(", ");
  return JSON.stringify(d);
};

export const formatINR = (n) => `₹${Number(n).toLocaleString("en-IN")}`;

export const waLink = (msg) => {
  const phone = "919654861504";
  return `https://wa.me/${phone}?text=${encodeURIComponent(msg)}`;
};
